import envConfig from '@nile/home/src/Config/env';
import * as _ from 'lodash';
import {
  toast,
  getHeaderValue,
  SecurityConfig,
  fetchApi
} from '@nile/components';
import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import OtpInput from 'react-otp-input';
import { FormattedMessage, injectIntl } from 'react-intl';

const TFAPage = (props) => {
  const [buttonLoader, setButtonLoader] = useState(false);
  const handleSave = async (code) => {
    const { data } = props.location;

    if (!data) {
      toast('warning', 'tfa.missing.creds.warning.message');
      setButtonLoader(false);
      return;
    }

    const formData = new FormData();
    formData.append('username', data.username);
    formData.append('password', data.password);

    if (code.length === 6) formData.append('passcode', code);
    else formData.append('backupCode', code);

    const requestOptions = {
      method: 'POST',
      body: formData,
      credentials: 'include',
      headers: getHeaderValue()
    };

    const response = await fetchApi(
      `${envConfig.loginRoot}/login?trustdurationenable=${data.trustme}`,
      requestOptions
    );
    if (response.status === 200) {
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    }

    if (response.status !== 200) {
      // setTfaCode('');
      toast('error', `app.errorCode.${response?.status}`);
    }
    setButtonLoader(false);
  };

  const handleData = (code) => {
    if (code.length === 6 || code.length === 8) {
      setButtonLoader(true);
      handleSave(code);
    }
  };

  if (!props?.location?.data) {
    props.history.push('/login');
  }

  return (
    <SecurityConfig
      buttonLoader={buttonLoader}
      handleData={handleData}
      isPublic
      renderType={'passcode'}
    />
  );
};

export default injectIntl(withRouter(TFAPage));
